import { Injectable, Optional, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ZcWidgetCoreService {
  siteConfig: any;
  constructor(@Inject('config') private config: any) {
    console.log('_siteTest', config);
    console.log('siteConfig _siteTest', this.siteConfig);
    // this.siteConfig = config;
  }
}
